//Libs
import { Timestamp } from "firebase/firestore";

//Local
import { ExistingCraftRecord } from "../../models/craft-record";
import { ExistingVehicle } from "../../models/vehicle";
import { convertToReadableTimestamp } from "./convertToReadableTimestamp";
import { flattenObj } from "./flatten";
import { getTimeDifferenceInDays } from "../../utils/getTimeDifferenceInDays";

export function formatWRDataForExcelExport(
  workRecordList: ExistingCraftRecord[],
  userDisplayNamesMap: Record<string, string>,
  getLocationTitle: (id: string) => string,
  vehicleList: ExistingVehicle[],
): Record<string, any>[] {
  function renderNumberDaysStanding(
    timestampMarkedInstalled: Timestamp | undefined,
  ) {
    if (timestampMarkedInstalled == null) {
      return "0";
    } else {
      const startDate: Timestamp = timestampMarkedInstalled;
      const endDate = Timestamp.now();

      //ACTION
      const daysDifference = getTimeDifferenceInDays({ startDate, endDate });
      return `${daysDifference}`;
    }
  }

  function renderVechicleName(assetID: string | null) {
    const currentVehicle = vehicleList.find(
      (vehicle) => vehicle.id === assetID,
    );
    return currentVehicle ? currentVehicle.title : "";
  }

  const result = workRecordList.map((workRecord) => {
    const asset =
      vehicleList.length >= 1
        ? { assetID: renderVechicleName(workRecord.assetID) }
        : null;
    return {
      ...flattenObj(workRecord),
      location: getLocationTitle(workRecord.locationID),
      createdBy: userDisplayNamesMap[workRecord.createdBy],
      "craftDetails.timestampMarkedInstalled": renderNumberDaysStanding(
        workRecord.craftDetails["timestampMarkedInstalled"],
      ),
      timestampRecordCreated: convertToReadableTimestamp(
        workRecord.timestampRecordCreated,
      ),
      ...asset,
    };
  });

  return result;
}
